<template>
  <div class="lg:py-6 sm:py-4 md:py-4" v-if="$breadcrumbs.length">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        :to="{ path: '' }"
        v-for="(crumb, indx) in $breadcrumbs"
        :key="indx"
      >
        <!-- {{ getBreadcrumb(crumb.meta.breadcrumb) }} -->
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  methods: {
    getBreadcrumb(bc) {
      return typeof bc === "function" ? bc.call(this, this.$route.params) : bc;
    },
    getPath(crumb) {
      let { path } = crumb;
      for (let [key, value] of Object.entries(this.$route.params)) {
        path = path.replace(`:${key}`, value);
      }
      return path;
    },
  },
};
</script>

<style></style>
